export default "__VITE_ASSET__YKURzc8M__"